import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Portfolio from "../pages/portfolio/page";
import AlbumPage from "../pages/portfolio/AlbumPage";
import Gallery from "../pages/galeria/page";
import Blog from "../pages/blog/page";
import Contato from "../pages/contato/page";
import AdminPortfolio from "@/pages/admin/portfolio/page";
import AdminLogin from "@/pages/admin/login/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/portfolio/:albumId",
    element: <AlbumPage />,
  },
  {
    path: "/galeria",
    element: <Gallery />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/portfolio",
    element: <AdminPortfolio />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;